import React from 'react';
import { PublicationCard, type Publication } from './PublicationCard';
const PUBLICATIONS: Publication[] = [{
  id: 'pub-1',
  title: 'Langzeitergebnisse der robotergestützten radikalen Prostatektomie bei Patienten mit intermediärem Risikoprofil: Eine monozentrische Analyse',
  journal: 'Der Urologe',
  year: 2025,
  authors: ['Khoanh Nam Ta', 'Hans-Peter Müller', 'Friedrich Schneider', 'Ulrike Becker'],
  abstract: 'Diese Studie untersucht die onkologischen Langzeitergebnisse nach robotergestützter radikaler Prostatektomie (RARP) bei einer großen Kohorte von Patienten mit intermediärem Risiko-Prostatakarzinom. Unsere Ergebnisse zeigen eine exzellente Tumorkontrolle bei akzeptablen funktionellen Ergebnissen über einen Nachbeobachtungszeitraum von zehn Jahren.',
  tags: ['Prostatakarzinom', 'Urologie', 'Roboterchirurgie'],
  doi: '10.1007/s00120-025-2134-5',
  coverColor: '#2E4053' // Dark slate
}, {
  id: 'pub-2',
  title: 'Kombinierte Anwendung von Sägepalmenextrakt und Pygeum africanum bei benignem Prostatasyndrom: Eine Übersicht der aktuellen Evidenz',
  journal: 'Aktuelle Urologie',
  year: 2025,
  authors: ['Khoanh Nam Ta', 'Klaus-Dieter Braun', 'Matthias Hofmann', 'Stefan Zimmermann'],
  abstract: 'Diese Übersichtsarbeit fasst die aktuelle wissenschaftliche Evidenz zur kombinierten Anwendung von Sägepalmenextrakt (Serenoa repens) und Pygeum africanum bei ...',
  tags: ['Phytotherapie', 'Sägepalme', 'Pygeum', 'BPS'],
  doi: '10.1055/a-2025-1456',
  coverColor: '#7B241C' // Dark red
}, {
  id: 'pub-3',
  title: 'MRI-Targeted Biopsy versus Systematic Biopsy for Clinically Significant Prostate Cancer Detection: A Prospective Cohort Study',
  journal: 'The Lancet Oncology',
  year: 2023,
  authors: ['Oleksandr Kovalenko', 'Wolfgang Krause', 'Khoanh Nam Ta', 'Dmytro Shevchenko'],
  abstract: 'This prospective cohort study assesses the diagnostic accuracy of multiparametric MRI-targeted biopsy compared to standard systematic transrectal ultrasound-guided biopsy. The targeted approach demonstrated superior detection rates for clinically significant disease while reducing the overdiagnosis of indolent cancers.',
  tags: ['Diagnostics', 'MRI', 'Prostate Cancer'],
  doi: '10.1016/S1470-2045(23)00112-X',
  coverColor: '#1A5276' // Dark blue
}, {
  id: 'pub-4',
  title: 'Perioperative Ergebnisse und funktionelle Erholung nach Retzius-schonender robotergestützter radikaler Prostatektomie',
  journal: 'BJU International',
  year: 2022,
  authors: ['Khoanh Nam Ta', 'Jürgen Fischer', 'Iryna Bondarenko'],
  abstract: 'Eine Analyse perioperativer Parameter und der frühen funktionellen Erholung (Kontinenz und Potenz) bei Patienten nach Retzius-schonender robotergestützter radikaler Prostatektomie. Die Retzius-schonende Technik war mit einer signifikant schnelleren Wiedererlangung der Harnkontinenz verbunden, ohne die chirurgischen Resektionsränder zu beeinträchtigen.',
  tags: ['Operationstechnik', 'Urologie', 'Funktionelle Ergebnisse'],
  doi: '10.1111/bju.15678',
  coverColor: '#0E6251' // Dark teal
}, {
  id: 'pub-5',
  title: 'Molecular Biomarkers for Risk Stratification in Localized Prostate Cancer: A Systematic Review and Meta-Analysis',
  journal: 'Cancer Research',
  year: 2021,
  authors: ['Sabine Hartmann', 'Khoanh Nam Ta', 'Andriy Melnyk', 'Katrin Lehmann'],
  abstract: 'A comprehensive systematic review and meta-analysis evaluating the clinical utility of commercially available genomic classifiers and molecular biomarkers for risk stratification in men with newly diagnosed localized prostate cancer. Evidence supports their use in guiding treatment intensity decisions.',
  tags: ['Biomarkers', 'Genomics', 'Oncology'],
  doi: '10.1158/0008-5472.CAN-21-0987',
  coverColor: '#4A235A' // Dark purple
}, {
  id: 'pub-6',
  title: 'Impact of 5-Alpha Reductase Inhibitors on Prostate Cancer Incidence and Mortality: A Population-Based Longitudinal Study',
  journal: 'JAMA Oncology',
  year: 2020,
  authors: ['Michael T. Johnson', 'David K. Williams', 'Khoanh Nam Ta'],
  abstract: 'This large-scale population-based longitudinal study investigates the long-term impact of 5-alpha reductase inhibitor use on the incidence of prostate cancer and disease-specific mortality. While overall incidence was reduced, no significant difference in prostate cancer-specific mortality was observed.',
  tags: ['Epidemiology', 'Prevention', 'Urology'],
  doi: '10.1001/jamaoncol.2020.3456',
  coverColor: '#17202A' // Almost black
}, {
  id: 'pub-7',
  title: 'Transperineal Prostate Biopsy Under Local Anesthesia: Safety, Tolerability, and Cancer Detection Rates',
  journal: 'Prostate Cancer and Prostatic Diseases',
  year: 2019,
  authors: ['Khoanh Nam Ta', 'Thomas Anderson', 'Elena Rodriguez'],
  abstract: 'Evaluating the feasibility, patient tolerability, and infectious complication rates of free-hand transperineal prostate biopsy performed under local anesthesia in an outpatient setting. The procedure demonstrated excellent safety profiles with near-zero sepsis rates and comparable cancer detection to transrectal approaches.',
  tags: ['Biopsy', 'Clinical Outcomes', 'Urology'],
  doi: '10.1038/s41391-019-0123-4',
  coverColor: '#7D6608' // Dark gold/olive
}, {
  id: 'pub-8',
  title: 'Neues Nomogramm zur Vorhersage der Lymphknoteninvasion bei Hochrisiko-Prostatakarzinom-Patienten mit erweiterter pelviner Lymphadenektomie',
  journal: 'Urology',
  year: 2025,
  authors: ['Khoanh Nam Ta', 'Natalia Tkachenko', 'Viktor Lysenko'],
  abstract: 'Wir haben ein neues klinisches Nomogramm entwickelt und intern validiert, das multiparametrische MRT-Daten und Ergebnisse gezielter Biopsien integriert, um die Wahrscheinlichkeit einer Lymphknoteninvasion vorherzusagen. Dieses Instrument soll Klinikern helfen, jene Hochrisiko-Prostatakarzinom-Patienten zu identifizieren, die am meisten von einer erweiterten pelvinen Lymphadenektomie profitieren.',
  tags: ['Nomogramm', 'Lymphadenektomie', 'Prostatakarzinom'],
  doi: '10.1016/j.urology.2025.01.045',
  coverColor: '#34495E'
}, {
  id: 'pub-9',
  title: 'Quality of Life After Focal Therapy for Localized Prostate Cancer: A Multi-Institutional Prospective Registry Analysis',
  journal: 'World Journal of Urology',
  year: 2025,
  authors: ['Daniel H. Kim', 'Khoanh Nam Ta', 'Samuel L. Jackson', 'Rachel E. Adams'],
  abstract: 'This multi-institutional study analyzed patient-reported quality of life outcomes up to 5 years following focal therapy for localized prostate cancer. Results show excellent preservation of genitourinary function compared to radical whole-gland treatments, with acceptable mid-term oncological control.',
  tags: ['Focal Therapy', 'Quality of Life', 'Urology'],
  doi: '10.1007/s00345-2025-04892-1',
  coverColor: '#1F618D'
}, {
  id: 'pub-10',
  title: 'Künstliche Intelligenz in der Prostatapathologie: Automatisierte Gleason-Graduierung und Tumorquantifizierung',
  journal: 'Nature Reviews Urology',
  year: 2023,
  authors: ['Khoanh Nam Ta', 'Oksana Marchenko', 'Taras Boyko'],
  abstract: 'Ein umfassender Überblick über aktuelle Fortschritte bei Deep-Learning-Algorithmen zur automatisierten Gleason-Graduierung von Prostatabiopsie-Präparaten. Wir diskutieren die klinische Integration dieser KI-Werkzeuge, ihre Leistungsfähigkeit im Vergleich zu erfahrenen Uropathologen und zukünftige Entwicklungen in der computergestützten Pathologie.',
  tags: ['Künstliche Intelligenz', 'Pathologie', 'Gleason-Score'],
  doi: '10.1038/s41585-023-00789-x',
  coverColor: '#117864'
}, {
  id: 'pub-11',
  title: 'Salvage Radiotherapy vs Salvage Radical Prostatectomy for Radiation-Resistant Prostate Cancer',
  journal: 'Journal of Clinical Oncology',
  year: 2023,
  authors: ['Marcus T. Wright', 'Khoanh Nam Ta', 'Olivia C. Bennett', 'James R. Smith'],
  abstract: 'A retrospective propensity-score matched analysis comparing oncological and functional outcomes between salvage radiotherapy and salvage radical prostatectomy in patients with local recurrence after primary radiation therapy. Salvage surgery demonstrated superior local control but higher rates of severe urinary incontinence.',
  tags: ['Salvage Therapy', 'Radiotherapy', 'Oncology'],
  doi: '10.1200/JCO.23.01234',
  coverColor: '#76448A'
}, {
  id: 'pub-12',
  title: 'The Role of PSMA PET/CT in Staging High-Risk Prostate Cancer Prior to Initial Therapy',
  journal: 'Urologic Oncology',
  year: 2023,
  authors: ['Khoanh Nam Ta', 'Benjamin S. Carter', 'Sophia L. Martinez'],
  abstract: 'Evaluating the impact of Prostate-Specific Membrane Antigen (PSMA) PET/CT on initial staging and subsequent management changes in men with newly diagnosed high-risk prostate cancer. PSMA PET/CT detected occult metastases in 22% of patients, leading to significant alterations in planned treatment strategies.',
  tags: ['PSMA PET', 'Imaging', 'Staging'],
  doi: '10.1016/j.urolonc.2023.03.015',
  coverColor: '#922B21'
}, {
  id: 'pub-13',
  title: 'Einfluss des chirurgischen Zugangswegs auf positive Resektionsränder bei radikaler Prostatektomie: Offen vs. robotergestützt',
  journal: 'International Journal of Urology',
  year: 2022,
  authors: ['Hans-Peter Müller', 'Khoanh Nam Ta', 'Oleksandr Kovalenko'],
  abstract: 'Eine große Kohortenstudie zum Vergleich der Häufigkeit und Lokalisation positiver Resektionsränder zwischen offener retropubischer und robotergestützter radikaler Prostatektomie. Während die Gesamtrate positiver Ränder vergleichbar war, zeigte der robotergestützte Ansatz signifikant weniger apikale Ränder bei Patienten mit großvolumiger Erkrankung.',
  tags: ['Roboterchirurgie', 'Resektionsränder', 'Urologie'],
  doi: '10.1111/iju.14567',
  coverColor: '#283747'
}, {
  id: 'pub-14',
  title: 'Dietary Interventions and Prostate Cancer Progression: A Randomized Controlled Trial',
  journal: 'The New England Journal of Medicine',
  year: 2022,
  authors: ['Rachel E. Adams', 'Khoanh Nam Ta', 'David K. Williams', 'Elena Rodriguez'],
  abstract: 'Investigating the effect of a comprehensive lifestyle and dietary intervention on disease progression in men on active surveillance for low-risk prostate cancer. The intervention group showed a statistically significant delay in time to clinical progression and reduced need for definitive treatment at 3 years.',
  tags: ['Diet', 'Active Surveillance', 'Prevention'],
  doi: '10.1056/NEJMoa2201234',
  coverColor: '#148F77'
}, {
  id: 'pub-15',
  title: 'Genomic Profiling of African American Men with Early-Onset Prostate Cancer',
  journal: 'Cancer Research',
  year: 2022,
  authors: ['Khoanh Nam Ta', 'Marcus T. Wright', 'Sarah L. Chen'],
  abstract: 'A genomic analysis of tumor tissue from African American men diagnosed with prostate cancer before age 55, identifying distinct molecular alterations compared to matched Caucasian cohorts. These findings highlight potential biological drivers contributing to racial disparities in prostate cancer aggressiveness.',
  tags: ['Genomics', 'Health Disparities', 'Oncology'],
  doi: '10.1158/0008-5472.CAN-22-0456',
  coverColor: '#5B2C6F'
}, {
  id: 'pub-16',
  title: 'Efficacy of Neoadjuvant Hormonal Therapy Prior to Radical Prostatectomy for High-Risk Disease',
  journal: 'Annals of Surgery',
  year: 2021,
  authors: ['James R. Smith', 'Khoanh Nam Ta', 'William Davis'],
  abstract: 'A systematic review and meta-analysis assessing the pathological and survival outcomes of neoadjuvant androgen deprivation therapy followed by radical prostatectomy for high-risk localized prostate cancer. Neoadjuvant therapy significantly reduced positive surgical margin rates but did not improve overall survival.',
  tags: ['Neoadjuvant Therapy', 'Surgery', 'Prostate Cancer'],
  doi: '10.1097/SLA.0000000000004567',
  coverColor: '#641E16'
}, {
  id: 'pub-17',
  title: 'Entwicklung und Validierung eines urinbasierten Biomarker-Panels zur Detektion des hochgradigen Prostatakarzinoms',
  journal: 'European Urology',
  year: 2021,
  authors: ['Khoanh Nam Ta', 'Friedrich Schneider', 'Dmytro Shevchenko', 'Ulrike Becker'],
  abstract: 'Wir beschreiben die Entwicklung und multizentrische Validierung eines neuartigen Multiplex-Urin-Exosomen-Biomarker-Assays zur nicht-invasiven Detektion des hochgradigen (Gleason Grade Group ≥2) Prostatakarzinoms. Der Assay zeigte einen hohen negativen prädiktiven Wert und könnte unnötige Biopsien um 35 % reduzieren.',
  tags: ['Biomarker', 'Diagnostik', 'Urin-Assay'],
  doi: '10.1016/j.eururo.2021.08.022',
  coverColor: '#1A5276'
}, {
  id: 'pub-18',
  title: 'Management of Biochemical Recurrence After Primary Treatment for Prostate Cancer',
  journal: 'Nature Reviews Urology',
  year: 2021,
  authors: ['Olivia C. Bennett', 'Khoanh Nam Ta', 'Michael T. Johnson'],
  abstract: 'A comprehensive review of current guidelines and emerging evidence for the management of biochemical recurrence following radical prostatectomy or radiotherapy. We emphasize the integration of novel imaging modalities and genomic classifiers to personalize salvage treatment strategies.',
  tags: ['Biochemical Recurrence', 'Review', 'Urology'],
  doi: '10.1038/s41585-021-00456-y',
  coverColor: '#0E6655'
}, {
  id: 'pub-19',
  title: 'Racial Disparities in Access to Minimally Invasive Radical Prostatectomy',
  journal: 'JAMA Oncology',
  year: 2020,
  authors: ['Khoanh Nam Ta', 'Jessica M. Lin', 'Marcus T. Wright'],
  abstract: 'A population-based analysis using the SEER-Medicare database to evaluate trends and racial disparities in the utilization of robot-assisted radical prostatectomy. Despite overall increases in adoption, significant disparities persist, with minority patients less likely to undergo minimally invasive surgery.',
  tags: ['Health Disparities', 'Robotic Surgery', 'Epidemiology'],
  doi: '10.1001/jamaoncol.2020.1234',
  coverColor: '#1B4F72'
}, {
  id: 'pub-20',
  title: 'Active Surveillance for Favorable Intermediate-Risk Prostate Cancer: 10-Year Outcomes',
  journal: 'Journal of Clinical Oncology',
  year: 2020,
  authors: ['David K. Williams', 'Khoanh Nam Ta', 'Elena Rodriguez', 'Amanda White'],
  abstract: 'Reporting the 10-year oncological outcomes of a prospective cohort of men with favorable intermediate-risk prostate cancer managed with active surveillance. Metastasis-free survival remained high, suggesting active surveillance is a safe option for carefully selected patients in this risk category.',
  tags: ['Active Surveillance', 'Clinical Outcomes', 'Oncology'],
  doi: '10.1200/JCO.20.00789',
  coverColor: '#4A235A'
}, {
  id: 'pub-21',
  title: 'Komplikationen und Wiederaufnahmen nach transurethraler Resektion der Prostata vs. Laser-Enukleation',
  journal: 'BJU International',
  year: 2020,
  authors: ['Khoanh Nam Ta', 'Samuel L. Jackson', 'Christopher D. Lee'],
  abstract: 'Eine vergleichende Analyse der 30-Tage-Komplikationen und Krankenhauswiederaufnahmeraten zwischen monopolarer transurethraler Resektion der Prostata (TURP) und Holmium-Laser-Enukleation der Prostata (HoLEP) bei benignem Prostatasyndrom. HoLEP war mit kürzeren Krankenhausaufenthalten und weniger Blutungskomplikationen assoziiert.',
  tags: ['BPH', 'Chirurgische Komplikationen', 'Urologie'],
  doi: '10.1111/bju.15012',
  coverColor: '#78281F'
}, {
  id: 'pub-22',
  title: 'The Impact of Multidisciplinary Tumor Boards on Prostate Cancer Management Decisions',
  journal: 'Urologic Oncology',
  year: 2019,
  authors: ['Sophia L. Martinez', 'Khoanh Nam Ta', 'James R. Smith'],
  abstract: 'Evaluating the frequency and nature of changes in treatment recommendations for prostate cancer patients following review by a formal multidisciplinary tumor board. Case review resulted in altered management plans in 18% of cases, most commonly in the setting of locally advanced or oligometastatic disease.',
  tags: ['Tumor Board', 'Clinical Practice', 'Oncology'],
  doi: '10.1016/j.urolonc.2019.05.008',
  coverColor: '#154360'
}, {
  id: 'pub-23',
  title: 'Microbiome Alterations in the Urinary Tract of Men with Prostate Cancer',
  journal: 'Cancer Research',
  year: 2019,
  authors: ['Khoanh Nam Ta', 'Matthias Hofmann', 'Iryna Bondarenko', 'Stefan Zimmermann'],
  abstract: 'An exploratory study characterizing the urinary microbiome in men with and without prostate cancer using 16S rRNA gene sequencing. We identified distinct microbial signatures associated with high-grade prostate cancer, suggesting a potential role for the local microbiome in tumor pathogenesis.',
  tags: ['Microbiome', 'Pathogenesis', 'Urology'],
  doi: '10.1158/0008-5472.CAN-19-0345',
  coverColor: '#0B5345'
}, {
  id: 'pub-24',
  title: 'Cost-Effectiveness of MRI-Targeted Biopsy Strategies in Prostate Cancer Diagnosis',
  journal: 'European Urology',
  year: 2019,
  authors: ['Benjamin S. Carter', 'Khoanh Nam Ta', 'Rachel E. Adams'],
  abstract: 'A decision-analytic Markov model evaluating the cost-effectiveness of incorporating multiparametric MRI and targeted biopsy into the diagnostic pathway for biopsy-naïve men with elevated PSA. The MRI-first approach was found to be cost-effective at standard willingness-to-pay thresholds.',
  tags: ['Health Economics', 'MRI', 'Diagnostics'],
  doi: '10.1016/j.eururo.2019.02.034',
  coverColor: '#512E5F'
}, {
  id: 'pub-25',
  title: 'Long-term Cardiovascular Toxicity of Androgen Deprivation Therapy in Prostate Cancer Patients',
  journal: 'The Lancet Oncology',
  year: 2018,
  authors: ['Khoanh Nam Ta', 'Michael T. Johnson', 'Olivia C. Bennett'],
  abstract: 'A population-based cohort study examining the long-term risk of major adverse cardiovascular events in men receiving androgen deprivation therapy for localized prostate cancer. Prolonged ADT use was associated with a significantly increased risk of myocardial infarction and stroke compared to matched controls.',
  tags: ['Androgen Deprivation', 'Cardiovascular Risk', 'Oncology'],
  doi: '10.1016/S1470-2045(18)30567-8',
  coverColor: '#641E16'
}, {
  id: 'pub-26',
  title: 'Surgical Management of High-Risk Prostate Cancer: The Role of Extended Pelvic Lymph Node Dissection',
  journal: 'Journal of Urology',
  year: 2018,
  authors: ['William Davis', 'Khoanh Nam Ta', 'Thomas Anderson', 'Sarah L. Chen'],
  abstract: 'Reviewing the therapeutic and prognostic value of extended pelvic lymph node dissection during radical prostatectomy for high-risk prostate cancer. We discuss the anatomical templates, complication rates, and the impact of lymph node yield on biochemical recurrence-free survival.',
  tags: ['Lymph Node Dissection', 'Surgical Technique', 'Urology'],
  doi: '10.1016/j.juro.2018.04.012',
  coverColor: '#1A5276'
}, {
  id: 'pub-27',
  title: 'Patient-Reported Outcomes Following Stereotactic Body Radiotherapy for Localized Prostate Cancer',
  journal: 'International Journal of Urology',
  year: 2018,
  authors: ['Khoanh Nam Ta', 'Marcus T. Wright', 'Jessica M. Lin'],
  abstract: 'A prospective evaluation of early and late genitourinary and gastrointestinal toxicity, as well as patient-reported quality of life, following stereotactic body radiotherapy (SBRT) for low- and intermediate-risk prostate cancer. SBRT demonstrated excellent tolerability with transient acute toxicity.',
  tags: ['Radiotherapy', 'Quality of Life', 'Oncology'],
  doi: '10.1111/iju.13789',
  coverColor: '#0E6251'
}, {
  id: 'pub-28',
  title: 'Der Einfluss von Adipositas auf perioperative Ergebnisse bei robotergestützter radikaler Prostatektomie',
  journal: 'Urology',
  year: 2017,
  authors: ['Amanda White', 'Khoanh Nam Ta', 'Christopher D. Lee'],
  abstract: 'Analyse des Einflusses des Body-Mass-Index auf Operationszeit, geschätzten Blutverlust und Komplikationsraten in einer großen Kohorte von Patienten nach robotergestützter radikaler Prostatektomie. Während Adipositas die Operationszeit verlängerte, hatte sie keinen signifikanten Einfluss auf schwere Komplikationsraten oder positive Resektionsränder.',
  tags: ['Adipositas', 'Roboterchirurgie', 'Urologie'],
  doi: '10.1016/j.urology.2017.08.023',
  coverColor: '#4A235A'
}, {
  id: 'pub-29',
  title: 'Validation of the CAPRA Score in Predicting Prostate Cancer Mortality in a Diverse Population',
  journal: 'Cancer',
  year: 2017,
  authors: ['Khoanh Nam Ta', 'David K. Williams', 'Elena Rodriguez', 'James R. Smith'],
  abstract: 'External validation of the Cancer of the Prostate Risk Assessment (CAPRA) score for predicting prostate cancer-specific mortality in a diverse, multi-institutional cohort. The CAPRA score maintained high discriminative accuracy across different racial and ethnic groups.',
  tags: ['Risk Assessment', 'Prognosis', 'Oncology'],
  doi: '10.1002/cncr.30890',
  coverColor: '#7B241C'
}, {
  id: 'pub-30',
  title: 'Trends in the Management of Benign Prostatic Hyperplasia: A Decade of Medicare Data',
  journal: 'BJU International',
  year: 2017,
  authors: ['Samuel L. Jackson', 'Khoanh Nam Ta', 'Michael T. Johnson'],
  abstract: 'A retrospective analysis of Medicare claims data from 2005 to 2015 evaluating shifts in the surgical management of benign prostatic hyperplasia. We observed a significant decline in traditional TURP, accompanied by a rapid increase in the utilization of laser therapies and minimally invasive surgical therapies (MIST).',
  tags: ['BPH', 'Epidemiology', 'Urology'],
  doi: '10.1111/bju.13901',
  coverColor: '#154360'
}, {
  id: 'pub-31',
  title: 'The Role of Multiparametric MRI in Active Surveillance for Prostate Cancer',
  journal: 'World Journal of Urology',
  year: 2020,
  authors: ['Khoanh Nam Ta', 'Rachel E. Adams', 'Daniel H. Kim'],
  abstract: 'Evaluating the utility of serial multiparametric MRI in monitoring men on active surveillance for low-risk prostate cancer. Changes in MRI suspicion scores were strongly associated with pathological upgrading on subsequent confirmatory biopsies, supporting its use as a monitoring tool.',
  tags: ['Active Surveillance', 'MRI', 'Diagnostics'],
  doi: '10.1007/s00345-2020-1890-2',
  coverColor: '#0B5345'
}, {
  id: 'pub-32',
  title: 'Impact of Surgeon Volume on Outcomes After Radical Prostatectomy: A Systematic Review',
  journal: 'Annals of Surgery',
  year: 2020,
  authors: ['Katrin Lehmann', 'Khoanh Nam Ta', 'Andriy Melnyk', 'Wolfgang Krause'],
  abstract: 'A comprehensive systematic review examining the relationship between surgeon volume and perioperative, oncological, and functional outcomes following radical prostatectomy. Higher surgeon volume was consistently associated with lower complication rates and improved urinary continence recovery.',
  tags: ['Surgical Volume', 'Outcomes Research', 'Urology'],
  doi: '10.1097/SLA.0000000000001789',
  coverColor: '#512E5F'
}, {
  id: 'pub-33',
  title: 'Genomic Classifiers in the Management of Localized Prostate Cancer: Current Status and Future Directions',
  journal: 'Urologic Oncology',
  year: 2020,
  authors: ['Khoanh Nam Ta', 'Sarah L. Chen', 'Marcus T. Wright'],
  abstract: 'A critical review of commercially available tissue-based genomic classifiers (Decipher, Oncotype DX, Prolaris) for localized prostate cancer. We discuss their analytical validity, clinical utility, and integration into current clinical practice guidelines for risk stratification.',
  tags: ['Genomics', 'Biomarkers', 'Oncology'],
  doi: '10.1016/j.urolonc.2020.04.005',
  coverColor: '#641E16'
}, {
  id: 'pub-34',
  title: 'Erectile Function Recovery After Nerve-Sparing Radical Prostatectomy: A Prospective Analysis',
  journal: 'Journal of Sexual Medicine',
  year: 2019,
  authors: ['Christopher D. Lee', 'Khoanh Nam Ta', 'Jessica M. Lin'],
  abstract: 'A prospective longitudinal study assessing the timeline and predictors of erectile function recovery following bilateral nerve-sparing radical prostatectomy. Preoperative erectile function, patient age, and the quality of nerve sparing were the most significant predictors of recovery at 24 months.',
  tags: ['Erectile Dysfunction', 'Functional Outcomes', 'Urology'],
  doi: '10.1111/jsm.2019.12901',
  coverColor: '#1A5276'
}, {
  id: 'pub-35',
  title: 'The Learning Curve for Robot-Assisted Radical Prostatectomy: A Multi-Institutional Study',
  journal: 'European Urology',
  year: 2019,
  authors: ['Khoanh Nam Ta', 'James R. Smith', 'Elena Rodriguez', 'David K. Williams'],
  abstract: 'Analyzing the learning curve for robot-assisted radical prostatectomy across multiple high-volume centers. We define the number of cases required to achieve proficiency in terms of operative time, positive surgical margin rates, and early complication rates.',
  tags: ['Robotic Surgery', 'Surgical Education', 'Urology'],
  doi: '10.1016/j.eururo.2019.01.023',
  coverColor: '#0E6251'
}, {
  id: 'pub-36',
  title: 'Management of High-Grade Prostatic Intraepithelial Neoplasia on Extended Prostate Biopsy',
  journal: 'Prostate Cancer and Prostatic Diseases',
  year: 2019,
  authors: ['Olivia C. Bennett', 'Khoanh Nam Ta', 'Michael T. Johnson'],
  abstract: 'A retrospective review evaluating the risk of subsequent prostate cancer detection in men diagnosed with isolated high-grade prostatic intraepithelial neoplasia (HGPIN) on extended core biopsy. The risk of cancer on repeat biopsy was lower than historically reported, questioning the need for routine early re-biopsy.',
  tags: ['Pathology', 'Biopsy', 'Urology'],
  doi: '10.1038/pcan.2019.45',
  coverColor: '#4A235A'
}, {
  id: 'pub-37',
  title: 'The Role of Adjuvant Radiotherapy in Patients with Adverse Pathological Features After Radical Prostatectomy',
  journal: 'Journal of Clinical Oncology',
  year: 2019,
  authors: ['Khoanh Nam Ta', 'Benjamin S. Carter', 'Amanda White'],
  abstract: 'A critical analysis of the timing and efficacy of adjuvant versus early salvage radiotherapy in patients with positive surgical margins, extraprostatic extension, or seminal vesicle invasion following radical prostatectomy. We discuss the evolving paradigm favoring early salvage therapy.',
  tags: ['Radiotherapy', 'Adjuvant Therapy', 'Oncology'],
  doi: '10.1200/JCO.2019.56.7890',
  coverColor: '#7B241C'
}, {
  id: 'pub-38',
  title: 'Complications of Transrectal Ultrasound-Guided Prostate Biopsy: A Contemporary Analysis',
  journal: 'Urology',
  year: 2018,
  authors: ['Viktor Lysenko', 'Khoanh Nam Ta', 'Jürgen Fischer', 'Natalia Tkachenko'],
  abstract: 'A large contemporary series analyzing the incidence and risk factors for infectious and hemorrhagic complications following transrectal ultrasound-guided prostate biopsy. We highlight the rising rates of fluoroquinolone-resistant infections and discuss strategies for targeted prophylaxis.',
  tags: ['Biopsy', 'Complications', 'Urology'],
  doi: '10.1016/j.urology.2018.05.012',
  coverColor: '#154360'
}, {
  id: 'pub-39',
  title: 'Long-term Survival of Patients with Node-Positive Prostate Cancer Managed with Surgery and Adjuvant Therapy',
  journal: 'BJU International',
  year: 2018,
  authors: ['Khoanh Nam Ta', 'Sarah L. Chen', 'William Davis'],
  abstract: 'Evaluating the 15-year cancer-specific and overall survival of patients found to have lymph node metastases at the time of radical prostatectomy, managed with immediate adjuvant androgen deprivation therapy. Results support a multimodal approach for this high-risk cohort.',
  tags: ['Node-Positive Disease', 'Survival', 'Oncology'],
  doi: '10.1111/bju.2018.12345',
  coverColor: '#0B5345'
}, {
  id: 'pub-40',
  title: 'The Impact of Preoperative PSA Velocity on Outcomes After Radical Prostatectomy',
  journal: 'World Journal of Urology',
  year: 2018,
  authors: ['Marcus T. Wright', 'Khoanh Nam Ta', 'Elizabeth R. Taylor'],
  abstract: 'Investigating the prognostic value of preoperative PSA velocity in predicting biochemical recurrence and adverse pathology in men undergoing radical prostatectomy. High PSA velocity was independently associated with an increased risk of disease recurrence, even in low-risk patients.',
  tags: ['PSA', 'Prognosis', 'Urology'],
  doi: '10.1007/s00345-2018-0890-1',
  coverColor: '#512E5F'
}, {
  id: 'pub-41',
  title: 'Quality of Life Comparison Between Open and Robotic Radical Prostatectomy',
  journal: 'Journal of Urology',
  year: 2018,
  authors: ['Khoanh Nam Ta', 'Elena Rodriguez', 'James R. Smith', 'Rachel E. Adams'],
  abstract: 'A prospective, non-randomized comparison of patient-reported health-related quality of life outcomes between open retropubic and robot-assisted radical prostatectomy. Robotic surgery was associated with faster early convalescence, but long-term functional outcomes were comparable between the two approaches.',
  tags: ['Quality of Life', 'Robotic Surgery', 'Urology'],
  doi: '10.1016/j.juro.2018.02.034',
  coverColor: '#641E16'
}, {
  id: 'pub-42',
  title: 'The Role of 5-Alpha Reductase Inhibitors in the Management of Hematuria Secondary to BPH',
  journal: 'International Journal of Urology',
  year: 2018,
  authors: ['Jessica M. Lin', 'Khoanh Nam Ta', 'Michael T. Johnson'],
  abstract: 'Evaluating the efficacy of finasteride and dutasteride in managing refractory gross hematuria of prostatic origin. 5-alpha reductase inhibitors demonstrated significant efficacy in reducing the frequency and severity of bleeding episodes, often avoiding the need for surgical intervention.',
  tags: ['BPH', 'Hematuria', 'Urology'],
  doi: '10.1111/j.1442-2042.2018.02789.x',
  coverColor: '#1A5276'
}, {
  id: 'pub-43',
  title: 'Biochemical Recurrence Definitions Following Radical Prostatectomy: A Critical Appraisal',
  journal: 'Urologic Oncology',
  year: 2017,
  authors: ['Khoanh Nam Ta', 'David K. Williams', 'Sophia L. Martinez'],
  abstract: 'A critical review of the various definitions of biochemical recurrence following radical prostatectomy and their impact on reported outcomes and clinical trial design. We advocate for the standardization of the AUA definition (PSA ≥0.2 ng/mL with a confirmatory value) across all studies.',
  tags: ['Biochemical Recurrence', 'Methodology', 'Oncology'],
  doi: '10.1016/j.urolonc.2017.01.005',
  coverColor: '#0E6251'
}, {
  id: 'pub-44',
  title: 'Chirurgisches Management des Nierenzellkarzinoms mit venösem Tumorthrombus',
  journal: 'Annals of Surgery',
  year: 2017,
  authors: ['Klaus-Dieter Braun', 'Khoanh Nam Ta', 'Taras Boyko', 'Sabine Hartmann'],
  abstract: 'Eine retrospektive Analyse chirurgischer Techniken und Ergebnisse bei Patienten mit radikaler Nephrektomie und Thrombektomie der Vena cava inferior bei lokal fortgeschrittenem Nierenzellkarzinom. Eine multidisziplinäre chirurgische Planung ist entscheidend für die Optimierung der perioperativen Morbidität und Mortalität.',
  tags: ['Nierenzellkarzinom', 'Operationstechnik', 'Urologie'],
  doi: '10.1097/SLA.0b013e3181f2017',
  coverColor: '#4A235A'
}, {
  id: 'pub-45',
  title: 'Der Einfluss des Alters auf die Ergebnisse nach radikaler Prostatektomie',
  journal: 'Cancer',
  year: 2017,
  authors: ['Khoanh Nam Ta', 'Samuel L. Jackson', 'Olivia C. Bennett'],
  abstract: 'Analyse der onkologischen und funktionellen Ergebnisse der radikalen Prostatektomie bei Männern ab 70 Jahren im Vergleich zu einer jüngeren Kohorte. Ältere Männer wiesen ein höheres Risikoprofil auf, erzielten jedoch eine exzellente krebsspezifische Überlebensrate, wenngleich die Wiedererlangung der Harnkontinenz langsamer verlief.',
  tags: ['Geriatrische Onkologie', 'Chirurgie', 'Prostatakarzinom'],
  doi: '10.1002/cncr.2017.25012',
  coverColor: '#7B241C'
}, {
  id: 'pub-46',
  title: 'Dietary Fat Intake and the Risk of Prostate Cancer Progression',
  journal: 'JAMA',
  year: 2017,
  authors: ['Rachel E. Adams', 'Khoanh Nam Ta', 'James R. Smith', 'Elena Rodriguez'],
  abstract: 'A prospective cohort study investigating the association between dietary fat intake and the risk of lethal prostate cancer. High intake of saturated fats was associated with an increased risk of disease progression, while consumption of plant-based fats showed a protective effect.',
  tags: ['Diet', 'Epidemiology', 'Oncology'],
  doi: '10.1001/jama.2017.1234',
  coverColor: '#154360'
}, {
  id: 'pub-47',
  title: 'The Role of Neoadjuvant Chemotherapy in Muscle-Invasive Bladder Cancer',
  journal: 'European Urology',
  year: 2017,
  authors: ['Khoanh Nam Ta', 'William Davis', 'Sarah L. Chen'],
  abstract: 'A review of the evidence supporting the use of cisplatin-based neoadjuvant chemotherapy prior to radical cystectomy for muscle-invasive bladder cancer. We discuss the survival benefits, patient selection criteria, and the underutilization of this approach in clinical practice.',
  tags: ['Bladder Cancer', 'Chemotherapy', 'Urology'],
  doi: '10.1016/j.eururo.2017.03.045',
  coverColor: '#0B5345'
}, {
  id: 'pub-48',
  title: 'Predictors of Positive Surgical Margins Following Retropubic Radical Prostatectomy',
  journal: 'BJU International',
  year: 2017,
  authors: ['Oksana Marchenko', 'Khoanh Nam Ta', 'Hans-Peter Müller', 'Oleksandr Kovalenko'],
  abstract: 'A multivariate analysis identifying preoperative and intraoperative factors associated with positive surgical margins during open retropubic radical prostatectomy. High PSA, advanced clinical stage, and the decision to perform a nerve-sparing procedure were significant independent predictors.',
  tags: ['Surgical Margins', 'Prostatectomy', 'Urology'],
  doi: '10.1111/j.1464-410X.2017.07890.x',
  coverColor: '#512E5F'
}, {
  id: 'pub-49',
  title: 'The Utility of PCA3 in Predicting Prostate Cancer on Repeat Biopsy',
  journal: 'Journal of Urology',
  year: 2017,
  authors: ['Khoanh Nam Ta', 'Benjamin S. Carter', 'Marcus T. Wright'],
  abstract: 'Evaluating the diagnostic performance of the urinary Prostate Cancer Antigen 3 (PCA3) assay in men with a previous negative prostate biopsy and persistently elevated PSA. The PCA3 score demonstrated superior specificity compared to PSA alone in predicting a positive repeat biopsy.',
  tags: ['Biomarkers', 'Diagnostics', 'Urology'],
  doi: '10.1016/j.juro.2017.01.023',
  coverColor: '#641E16'
}, {
  id: 'pub-50',
  title: 'Management of Ureteral Strictures Following Treatment for Prostate Cancer',
  journal: 'Urology',
  year: 2017,
  authors: ['Thomas Anderson', 'Khoanh Nam Ta', 'Jessica M. Lin'],
  abstract: 'A retrospective review of the etiology and management of distal ureteral strictures occurring as a complication of radical prostatectomy or pelvic radiotherapy. We discuss the success rates of endoscopic management versus open ureteral reimplantation.',
  tags: ['Complications', 'Reconstructive Urology', 'Surgery'],
  doi: '10.1016/j.urology.2017.04.012',
  coverColor: '#1A5276'
}, {
  id: 'pub-51',
  title: 'The Impact of Family History on Prostate Cancer Characteristics and Outcomes',
  journal: 'Cancer',
  year: 2017,
  authors: ['Khoanh Nam Ta', 'David K. Williams', 'Amanda White', 'Samuel L. Jackson'],
  abstract: 'Analyzing the clinical presentation and pathological outcomes of men with a strong family history of prostate cancer compared to those with sporadic disease. Men with a family history presented at a younger age but did not exhibit more aggressive pathological features at the time of surgery.',
  tags: ['Genetics', 'Family History', 'Oncology'],
  doi: '10.1002/cncr.2017.22567',
  coverColor: '#0E6251'
}, {
  id: 'pub-52',
  title: 'Efficacy of Phosphodiesterase Type 5 Inhibitors in Post-Prostatectomy Erectile Dysfunction',
  journal: 'Journal of Sexual Medicine',
  year: 2017,
  authors: ['James R. Smith', 'Khoanh Nam Ta', 'Sophia L. Martinez'],
  abstract: 'A systematic review evaluating the efficacy and optimal timing of PDE5 inhibitors for penile rehabilitation and treatment of erectile dysfunction following nerve-sparing radical prostatectomy. Early initiation of therapy appears to improve long-term recovery of spontaneous erectile function.',
  tags: ['Erectile Dysfunction', 'Rehabilitation', 'Urology'],
  doi: '10.1111/j.1743-6109.2017.00234.x',
  coverColor: '#4A235A'
}, {
  id: 'pub-53',
  title: 'The Role of Bone Targeted Therapy in Metastatic Prostate Cancer',
  journal: 'Urologic Oncology',
  year: 2017,
  authors: ['Khoanh Nam Ta', 'Elena Rodriguez', 'Christopher D. Lee'],
  abstract: 'A review of the pathophysiology of bone metastases in prostate cancer and the clinical utility of bisphosphonates in preventing skeletal-related events. We discuss the indications, dosing, and potential complications, including osteonecrosis of the jaw.',
  tags: ['Bone Metastases', 'Palliative Care', 'Oncology'],
  doi: '10.1016/j.urolonc.2017.02.005',
  coverColor: '#7B241C'
}, {
  id: 'pub-54',
  title: 'Laparoskopische vs. offene radikale Prostatektomie: Eine monozentrische Erfahrung',
  journal: 'World Journal of Urology',
  year: 2017,
  authors: ['William Davis', 'Khoanh Nam Ta', 'Michael T. Johnson', 'Rachel E. Adams'],
  abstract: 'Bericht über unsere frühe institutionelle Erfahrung beim Übergang von der offenen retropubischen zur rein laparoskopischen radikalen Prostatektomie. Der laparoskopische Ansatz war mit geringerem Blutverlust und kürzeren Krankenhausaufenthalten verbunden, bei vergleichbaren frühen onkologischen Ergebnissen.',
  tags: ['Laparoskopie', 'Operationstechnik', 'Urologie'],
  doi: '10.1007/s00345-2017-0012-3',
  coverColor: '#154360'
}];
export function PublicationList() {
  return <div className="w-full bg-white border border-[#E0E0E0] rounded-lg shadow-sm" data-id="element-52">
      <div className="px-6 py-4 border-b border-[#E0E0E0] bg-[#F5F7F8] rounded-t-lg flex justify-between items-center" data-id="element-53">
        <h3 className="font-serif font-medium text-gray-900" data-id="element-54">
          Selected Publications
        </h3>
        <span className="text-sm text-gray-500" data-id="element-55">
          Sort by:{' '}
          <span className="text-gray-900 font-medium cursor-pointer" data-id="element-56">
            Year (Newest)
          </span>
        </span>
      </div>

      <div className="px-6" data-id="element-57">
        {PUBLICATIONS.map(pub => <PublicationCard key={pub.id} publication={pub} targetAuthor="Khoanh Nam Ta" data-id="element-58" />)}
      </div>

      <div className="px-6 py-4 border-t border-[#E0E0E0] bg-gray-50 rounded-b-lg text-center" data-id="element-59">
        <span className="text-sm text-gray-600" data-id="element-60">
          Showing 54 of 104 publications
        </span>
      </div>
    </div>;
}